export default function renderValue(option) {
  if (option == null) {
    return <span className="text-base">Select an option...</span>;
  }
  return <span>{option.label}</span>;
}
